import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Create_Api, Get_Api } from "../../ApiUrls";

function Signup() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('Hostess');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };


  const [UserName, setUserName] = useState('');
  const [Email, setEmail] = useState('');
  const [Password, setPassword] = useState('');
  const [Gender, setGender] = useState('');
  const [ModelType, setModelType] = useState('');
  const [IsUploading, setIsUploading] = useState(false);

  const UserSignUp = async () => {
    if (!UserName || !Email || !Number || !DOB || !Password || !Gender) {
      toast.error('All fields are required!');
      return;
    }
    if (Number.length !== 10) {
      toast.error('Please Enter Correct Phone Number');
      return;
    }
    try {
      setIsUploading(true)
      let data = {
        UserName,
        Email,
        DOB,
        Number: countryCode + Number,
        Password,
        Gender
      }
      const response = await Create_Api(`api/user/register`, data)
      console.log('User register Successfull:', response);
      localStorage.setItem('user', JSON.stringify(response?.data));
      localStorage.setItem('userType', JSON.stringify('User'));
      localStorage.setItem('userid', response?.data?.User?._id);
      localStorage.setItem('userToken', response?.data?.token);
      toast.success(response?.message);
      setUserName('')
      setEmail('')
      setNumber('')
      setPassword('')
      navigate('/allmodal')
      setIsUploading(false)
    } catch (error) {
      toast.success(error?.response?.data?.message);
      setIsUploading(false)
      console.log(error)
    }
  }


  const HostessSignUp = async () => {
    if (!UserName || !Email || !Number || !DOB || !Password || !ModelType || !Gender) {
      toast.error('All fields are required!');
      return;
    }
    if (Number.length !== 10) {
      toast.error('Please Enter Correct Phone Number');
      return;
    }
    try {
      setIsUploading(true)
      let data = {
        UserName,
        Email,
        DOB,
        Number: countryCode + Number,
        Password,
        ModelType,
        Gender
      }
      const response = await Create_Api(`api/hostess/register`, data)
      console.log('Hostess register Successfull:', response);
      localStorage.setItem('user', JSON.stringify(response?.data));
      localStorage.setItem('userType', JSON.stringify('Hostess'));
      localStorage.setItem('userid', response?.data?.Hostess?._id);
      localStorage.setItem('userToken', response?.data?.token);
      toast.success(response?.message);
      setUserName('')
      setEmail('')
      setNumber('')
      setPassword('')
      navigate('/addabout')
      setIsUploading(false)
    } catch (error) {
      toast.success(error?.response?.data?.message);
      setIsUploading(false)
      console.log(error)
    }
  }

  const [Isverify, setIsverify] = useState(false);

  const ShowVerify = () => {
    if (!UserName || !Email || !Number || !DOB || !Password || !ModelType) {
      toast.error('All fields are required!');
      return;
    }
    if (Number.length !== 10) {
      toast.error('Please Enter Correct Phone Number');
      return;
    }
    setIsverify(true)
  }
  const CloseVerify = () => {
    setIsverify(false)
  }
  const [DOB, setDOB] = useState("");
  const [Number, setNumber] = useState("");

  // Calculate the minimum date for 18 years old
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];

  const handleDOBChange = (e) => {
    const selectedDate = e.target.value;
    const selectedDOB = new Date(selectedDate);

    if (selectedDOB <= new Date(minDate)) {
      setDOB(selectedDate);
    } else {
      alert("You must be at least 18 years old.");
    }
  };
  const [countryCode, setCountryCode] = useState("+91");

  const [AllCountryCode, setAllCountryCode] = useState([]);

  const GetAllCountryCode = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllCountryNumber`);
      setAllCountryCode(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    GetAllCountryCode();
  }, []);


  return (
    <>
      <Navbar />
      <div className="login-div">
        <div className="login-form">
          {/* <div className="login-form-left2">
          </div> */}
          <div className="login-form-right">
            <div className="noacc">
              <p>Welcome to <span>Hostess</span></p>
            </div>
            <br />
            <h3>Sign up</h3>
            <br />
            <div className="tab-container">
              <div className="tabs">
                <button
                  className={activeTab === "Hostess" ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange('Hostess')}>
                  I am a Hostess/Model
                </button>
                <button
                  className={activeTab === "User" ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange('User')}>
                  I am Looking for a Hostess/Model
                </button>
              </div>
            </div>
            <br />
            <br />
            {activeTab === "Hostess" && (
              <>
                <label>Enter UserName</label>
                <input
                  type="text"
                  placeholder="UserName"
                  value={UserName}
                  onChange={(e) => { setUserName(e.target.value) }}
                />
                <br />
                <br />
                <label>Enter Email</label>
                <input
                  type="email"
                  placeholder="Enter email address"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <br />
                <label>Contact Number</label>
                <div className="countryandnumber">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                  >
                    {/* <option value="+1">+1 (USA)</option>
                    <option value="+91">+91 (India)</option>
                    <option value="+44">+44 (UK)</option>
                    <option value="+61">+61 (Australia)</option>
                    <option value="+81">+81 (Japan)</option>
                    <option value="+49">+49 (Germany)</option> */}
                    {AllCountryCode?.map((country) => (
                      <option key={country._id} value={country.Number}>
                        {country.Number} ({country.Country})
                      </option>
                    ))}
                  </select>
                  <input
                    type="number"
                    placeholder="Contact Number"
                    value={Number}
                    onChange={(e) => { setNumber(e.target.value) }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <br />
                <div className='dob'>
                  <div>
                    <label>Date Of Birth</label>
                    <input
                      type="date"
                      placeholder="Enter"
                      value={DOB}
                      max={minDate}
                      onChange={handleDOBChange}
                    />
                  </div>
                  <div className="signupGenderselect">
                    <label>Gender</label>
                    <select value={Gender} onChange={(e) => setGender(e.target.value)}>
                      <option value="" disabled>Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <br />
                <label>Enter your Password</label>
                <input
                  type="password"
                  placeholder="Enter your Password"
                  value={Password}
                  onChange={(e) => { setPassword(e.target.value) }}
                />
                <br />
                <br />
                <label>I am a </label>
                <br />
                <br />
                <label className="rad-div">
                  <input
                    className="rad"
                    type="radio"
                    name="ModelType"
                    value="Hostess/Model"
                    checked={ModelType === "Hostess/Model"}
                    onChange={(e) => setModelType(e.target.value)}
                  />
                  Hostess/Model
                </label>

                <div className="forget">
                  <br />
                  <button onClick={HostessSignUp}>Sign up</button>
                </div>
              </>
            )}
            {activeTab === "User" && (
              <>
                <label>Enter UserName</label>
                <input
                  placeholder="UserName "
                  value={UserName}
                  onChange={(e) => { setUserName(e.target.value) }}
                />
                <br />
                <label>Enter Email</label>
                <input
                  placeholder="Enter email address"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <br />
                <label>Contact Number</label>
                <div className="countryandnumber">
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                  >
                    {AllCountryCode?.map((country) => (
                      <option key={country._id} value={country?.Number}>
                        {country?.Number} ({country?.Country})
                      </option>
                    ))}
                    {/* <option value="+1">+1 (USA)</option>
                    <option value="+91">+91 (India)</option>
                    <option value="+44">+44 (UK)</option>
                    <option value="+61">+61 (Australia)</option>
                    <option value="+81">+81 (Japan)</option>
                    <option value="+49">+49 (Germany)</option> */}
                  </select>
                  <input
                    type="number"
                    placeholder="Contact Number"
                    value={Number}
                    onChange={(e) => { setNumber(e.target.value) }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <br />
                <div className='dob'>
                  <div>
                    <label>Date Of Birth</label>
                    <input
                      type="date"
                      placeholder="Enter"
                      value={DOB}
                      onChange={(e) => { setDOB(e.target.value) }}
                    />
                  </div>
                  <div className="signupGenderselect">
                    <label>Gender</label>
                    <select value={Gender} onChange={(e) => setGender(e.target.value)}>
                      <option value="" disabled>Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <br />
                <br />
                <label>Enter your Password</label>
                <input
                  type="password"
                  placeholder="Enter your Password"
                  value={Password}
                  onChange={(e) => { setPassword(e.target.value) }}
                />
                <br />
                <br />
                <div className="forget">
                  <br />
                  <button onClick={UserSignUp}>
                    {IsUploading ? 'Wait...' : 'Sign up'}
                  </button>
                </div>
              </>
            )}
            <br />
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Signup